import React, { useState } from "react";
import Utils from "../tools/Utils";

const Form = (props) => {
    const [wasValidated, setWasValidated] = useState(false);

    const handleSubmit = (e) => {
        if(props.isLoadingCallback)
            props.isLoadingCallback(true);

        if(e.target.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            Utils.Toast.fire({
                icon: 'error',
                text: 'Faltan campos obligatorios por llenar'
            });
            setWasValidated('was-validated');
        } else {
            e.preventDefault();
            e.stopPropagation();
            props.submitCallback(true);
        }
        if(props.isLoadingCallback)
            props.isLoadingCallback(false);
    }

    return(
        <form onSubmit={handleSubmit} className={`needs-validation ${wasValidated}`} noValidate>
            {props.children}
        </form>
    )
}

export default Form;